import { collapseDesignerAction } from '../designerReducer';

export const collapseDesigner = () => dispatch => {
  dispatch(collapseDesignerAction());
};
